module.exports = __webpack_public_path__ + "media/images/athlete-f9f744b714d30274bb778ff43d75aadc.png";